import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../../../atomic/Buttons/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import GenericModal from '../GenericModal';
import * as apiServices from '../../../../services/apiServices';
import { Program } from '../../../../core/model';
import { toast } from 'react-toastify';
import { LIMITS } from '../../../../core/constants';

const ModalStyled = styled(GenericModal)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 500px;
  padding: 30px 20px;
  // height: 200px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const ButtonStyled = styled(Button)`
  // margin-left: auto;
`

const InlineFieldError = styled.div`
  color: #e74c3c;
  font-weight: 600;
`;

const InputStyled = styled(Input)`
  margin: 20px 0 20px;
  display: block;
`

class CreateProgramModal extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      name: props.title ? props.title : '',
      program_type: '',
      touched: false,
      title: props.title,
    }
  }

  onSubmit = async () => {
    const { onSuccess } = this.props;
    const { name, program_type, title } = this.state;

    const programObj = new Program();
    programObj.name = name;
    programObj.program_type = program_type;
    programObj.title = title;

    apiServices.createProgram(programObj)
    .then(response => {
      onSuccess(response);
    })
    .catch(e => {
      console.log('component: ',this,e);
      toast.error(e.message);
    })
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { children, onSuccess, title, wellness ,...other} = this.props
    const { name, program_type, touched } = this.state;

    return (
      <ModalStyled {...other}>
        {wellness ?<> <InputLabel htmlFor="name">Name</InputLabel>
        <InputStyled
          placeholder="Strength with Bands"
          onChange={this.handleChange}
          onKeyPress={(ev) => (ev.key === 'Enter') ? this.onSubmit() : null}
          inputProps={{ name: 'name', maxLength: LIMITS.programs.name}}
          defaultValue={name}
        />
        <ButtonContainer>
          <ButtonStyled  variant='contained' onClick={this.onSubmit}>Create New Program</ButtonStyled>
        </ButtonContainer>
        </>
        :
        <>
        <InputLabel htmlFor="name">Name</InputLabel>
        <InputStyled
          placeholder="Strength with Bands"
          onChange={this.handleChange}
          onKeyPress={(ev) => (ev.key === 'Enter') ? this.onSubmit() : null}
          inputProps={{ name: 'name', maxLength: LIMITS.programs.name }}
        />
        {name === '' && touched && <InlineFieldError>Please enter a program name.</InlineFieldError>}
        <InputLabel htmlFor="program-type">Program Type</InputLabel>
        <Select
          value={program_type}
          onChange={this.handleChange}
          inputProps={{ name: 'program_type', id: 'program-type', }}
        >
          <MenuItem value="standard">Standard</MenuItem>
          <MenuItem value="wellness">Corporate Wellness</MenuItem>
        </Select>
        <ButtonContainer>
          <ButtonStyled disabled={name === '' || program_type === ''} variant='contained' onClick={this.onSubmit}>Create New Program</ButtonStyled>
        </ButtonContainer>
        </>
        }
      </ModalStyled>
    );
  }

}

CreateProgramModal.propTypes = {
  onSubmit: PropTypes.func,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
};

CreateProgramModal.defaultProps = {
  title: '',
}

export default CreateProgramModal;
